export let reportTypes = [
  { name: 'ABC', id: 1, macro: false },
  { name: 'Company Initiation Reports', id: 7, macro: false },
  { name: 'Company Earnings Updates', id: 8, macro: true },
  { name: 'Sector Reports', id: 3, macro: false },
  { name: 'Daily Market Reports', id: 4, macro: false },
];
export let sectors = [
  {
    name: 'All',
    id: 1,
    companies: [
      { name: 'Company 1', id: 1 },
      { name: 'Company 2', id: 2 },
      { name: 'Company 3', id: 3 },
      { name: 'Company 4', id: 4 },
    ],
  },
  {
    name: 'Sector 1',
    id: 2,
    companies: [
      { name: 'AA', id: 6 },
      { name: 'AA 2', id: 7 },
      { name: 'AA 3', id: 8 },
      { name: 'AA 4', id: 9 },
    ],
  },
  {
    name: 'Sector 2',
    id: 3,
    companies: [
      { name: 'BB 1', id: 11 },
      { name: 'BB 2', id: 12 },
      { name: 'BB 3', id: 13 },
      { name: 'BB 4', id: 14 },
    ],
  },
  {
    name: 'Sector 3',
    id: 4,
    companies: [
      { name: 'CC 1', id: 16 },
      { name: 'CC 2', id: 17 },
      { name: 'CC 3', id: 18 },
      { name: 'CC 4', id: 19 },
    ],
  },
  {
    name: 'Sector 4',
    id: 5,
    companies: [
      { name: 'DD 1', id: 21 },
      { name: 'DD 2', id: 22 },
      { name: 'DD 3', id: 23 },
      { name: 'DD 4', id: 24 },
    ],
  },
];
export let companies = [
  { name: 'Company 1', id: 25 },
  { name: 'Company 2', id: 26 },
  { name: 'Company 3', id: 27 },
  { name: 'Company 4', id: 28 },
];
export let userSettingReportFrequency = [
  { name: 'Daily', id: 'DAILY' },
  { name: 'Weekly', id: 'WEEKLY' },
  { name: 'Monthly', id: 'MONTHLY' },
];

export let userSettingReportPeriod = [
  { name: 'Today', id: 'TODAY' },
  { name: 'Last Week', id: 'LAST_WEEK' },
  { name: 'Last Month', id: 'LAST_MONTH' },
  { name: 'YTD', id: 'YTD' },
];

export let userInfo = [
  { id: 'gender', name: 'Gender', subLevel: '', type: '' },

  { id: 'title', name: 'Title', subLevel: '', type: '' },

  { id: 'firstName', name: 'first Name', subLevel: '', type: '' },
  { id: 'lastName', name: 'lastName', subLevel: '', type: '' },
  { id: 'initials', name: 'Initials', subLevel: '', type: '' },

  { id: 'namesDenotedByInitials', name: 'Names Denoted by Initials', subLevel: '', type: '' },

  { id: 'dateOfBirth', name: 'Date of Birth', subLevel: '', type: '' },

  { id: 'nationality', name: 'Nationality', subLevel: '', type: '' },
  { id: 'nicDateOfIssue', name: 'NIC Date Of Issue', subLevel: '', type: '' },
  { id: 'passportDateOfIssue', name: 'Passport Date Of Issue', subLevel: '', type: '' },

  // { id: '_attachmentNIC', name: 'NIC attachment', subLevel: '', type: '' },
  // { id: '_attachmentPASSPORT', name: 'PASSPORT attachment', subLevel: '', type: '' },
];
export let addressFieldsList = [
  { id: 'permanentAddress', name: 'Permanent Address', subLevel: true, type: 'address' },

  { id: 'correspondenceAddress', name: 'Correspondence Addres', subLevel: true, type: 'address' },
];

export let editableFieldsInProduct = [
  { id: 'MobileNumber', name: 'Mobile No', subLevel: true, type: 'mobile' },
  { id: 'telephoneNumber', name: 'Telephone No', subLevel: true, type: 'tele' },

  { id: 'businessPhoneNumber', name: 'Business Tel No', subLevel: true, type: 'btele' },
  { id: 'businessFaxNumber', name: 'Business Fax No', subLevel: true, type: 'bfax' },
];
export let occupationInProduct = [
  { id: 'natureOfBusiness', name: 'Nature of Employment', subLevel: '', type: '' },
  { id: 'occupation', name: 'Occupation', subLevel: '', type: '' },
  { id: 'organizationName', name: 'Organization / Business Name', subLevel: '', type: '' },
  { id: 'businessAddress', name: 'Organization / Business Address', subLevel: '', type: '' },
  { id: 'businessEmail', name: 'Business Email', subLevel: '', type: '' },
  { id: 'taxFileNo', name: 'Tax File No', subLevel: '', type: '' },
  { id: 'mailingInstructions', name: 'Mailing Instructions', subLevel: '', type: '' },
];
export let otherInfoInProduct = [
  { id: 'recieveSmsAlerts', name: 'Recieve SMS Alerts', subLevel: '', type: '' },
  { id: 'currency', name: 'Currency', subLevel: '', type: '' },
  { id: 'expectedValueOfInvesment', name: 'Expected Value of Investment', subLevel: '', type: '' },
  { id: 'paymentInstructionOther', name: 'Other Payment Instructions', subLevel: '', type: '' },
  { id: 'sourceOfFunds', name: 'Source of Funds', subLevel: '', type: '' },
  { id: 'sourceOfFundsOther', name: 'Source of Funds Other', subLevel: '', type: '' },
  // { id: 'assignAuthorizedInstructor', name: 'Assign Authorized Instructor', subLevel: '', type: '' },
  { id: 'authorizedInstructor', name: 'Authorized Instructor', subLevel: '', type: '' },
  { id: 'authorizedInstructorNic', name: 'Authorized InstructorNic', subLevel: '', type: '' },
  { id: 'fatcaNo', name: 'FATCA Number', subLevel: '', type: '' },
  { id: 'fatcaStatus', name: 'FATCA Status', subLevel: '', type: '' },
];

export let cdsInfoInProduct = [
  { id: 'cdsStatusOfResidencyAddress', name: 'Status Of Residency Address', subLevel: '', type: '' },
  { id: 'cdsStatusOfResidencyAddressOther', name: 'Status Of Residency Address  Other', subLevel: '', type: '' },
  { id: 'cdsExpectedValueOfInvestment', name: 'CDS Expected Value of Investment', subLevel: '', type: '' },
  {
    id: '_cdsDualCitizenship1Country',
    arrayIndex: 0,
    field: 'country',
    name: 'Duel Citizenship Country 1',
    subLevel: true,
    type: 'cdsDualCitizenship',
  },
  {
    id: '_cdsDualCitizenship1Passport',
    arrayIndex: 0,
    field: 'passport',
    name: 'Duel Citizenship Passport 1',
    subLevel: true,
    type: 'cdsDualCitizenship',
  },

  {
    id: '_cdsDualCitizenship2Country',
    arrayIndex: 1,
    field: 'country',
    name: 'Duel Citizenship Country 2',
    subLevel: true,
    type: 'cdsDualCitizenship',
  },
  {
    id: '_cdsDualCitizenship2Passport',
    arrayIndex: 1,
    field: 'passport',
    name: 'Duel Citizenship Passport 2',
    subLevel: true,
    type: 'cdsDualCitizenship',
  },
  {
    id: '_cdsDualCitizenship3Country',
    arrayIndex: 2,
    field: 'country',
    name: 'Duel Citizenship Country 3',
    subLevel: true,
    type: 'cdsDualCitizenship',
  },
  {
    id: '_cdsDualCitizenship3Passport',
    arrayIndex: 2,
    field: 'passport',
    name: 'Duel Citizenship Passport 3',
    subLevel: true,
    type: 'cdsDualCitizenship',
  },
  { id: 'cdsPoliticallyExposedPersonsQ1Text', name: 'Politically Exposed Persons 1', subLevel: '', type: '' },
  { id: 'cdsPoliticallyExposedPersonsQ2Text', name: 'Politically Exposed Persons 2', subLevel: '', type: '' },
  { id: 'cdsPoliticallyExposedPersonsQ3Text', name: 'Politically Exposed Persons 3', subLevel: '', type: '' },
  { id: 'cdsPoliticallyExposedPersonsQ4Text', name: 'Politically Exposed Persons 4', subLevel: '', type: '' },
  { id: 'cdsCriminalProceedings1', name: 'Criminal Proceedings Details  1', subLevel: '', type: '' },
  { id: 'cdsCriminalProceedings2', name: 'Criminal Proceedings Details  2', subLevel: '', type: '' },
  { id: 'cdsCriminalProceedings3', name: 'Criminal Proceedings Details  3', subLevel: '', type: '' },
  {
    id: 'cdsAnyOtherConnectedBusinessesProfessionalActivities',
    name: 'Any Other Connected Businesses / Professional Activities',
    subLevel: '',
    type: '',
  },

  { id: 'cdsOtherRemarks', name: 'CDS Other Remarks', subLevel: '', type: '' },
];

export const roles = [
  { description: 'Administrator', role: 'ROLE_ADMIN', selected: false },
  { description: 'CRM X User', role: 'ROLE_CRM_X_USER', selected: false },
  { description: 'CRM X Editor', role: 'ROLE_CRMX_EDITOR', selected: false },
  { description: 'Customer', role: 'ROLE_CUSTOMER', selected: false },
  { description: 'Compliance', role: 'ROLE_COMPLIANCE', selected: false },
  { description: 'Senior Doc Officer', role: 'ROLE_SENIOR_DOCUMENTATION_OFFICER', selected: false },
  { description: 'Documentation Officer', role: 'ROLE_DOCUMENTATION_OFFICER', selected: false },
  { description: 'Macro Event Viewer', role: 'ROLE_MACRO_VIEWER', selected: false },
  { description: 'PWM User', role: 'ROLE_PWM_USER', selected: false },
  { description: 'PWM Editor', role: 'ROLE_PWM_EDITOR', selected: false },
  { description: 'PWM Reviewer', role: 'ROLE_PWM_REVIEWER', selected: false },
  { description: 'Research Administrator', role: 'ROLE_RESEARCH_ADMIN', selected: false },
  { description: 'RM CALI', role: 'ROLE_RM_CALI', selected: false },
  { description: 'RM CALS', role: 'ROLE_RM_CALS', selected: false },
  { description: 'RM CALT', role: 'ROLE_RM_CALT', selected: false },
  { description: 'RM PWM', role: 'ROLE_RM_PWM', selected: false },
  { description: 'Non Product RM', role: 'ROLE_NON_PRODUCT_RM', selected: false },
  { description: 'RM Corporate Finance', role: 'ROLE_RM_CORP_FIN', selected: false },
];
export const privilegesBK = [
  'ACTIVATE_USER',
  'ADMIN_OPTIONS',
  'APPROVE_PWM_REPORTS',
  'CONFIGURE_PWM_REPORTS',
  'CREATE_CRM_X_USER',
  'CREATE_PRODUCT',
  'CREATE_PWM_CUSTOMER_GROUPS',
  'CRM_X_VIEW_ONLY',
  'CUSTOMER_OPTIONS',
  'DOWNLOAD_REPORTS',
  'DOWNLOAD_CUSTOMER_LIST',
  'EDIT_PROFILE',
  'EMAIL_PWM_REPORT',
  'LIST_CUSTOMER',
  'MANAGE_CORP_FIN_USERS',
  'MANAGE_MACRO_EVENTS',
  'MONITOR_PRODUCT_SIGNUPS',
  'PRODUCT_SIGNUP',
  'RESEARCH_PORTAL_FULL_ACCESS',
  'RESEARCH_PORTAL_NO_ACCESS',
  'RESEARCH_PORTAL_PARTIAL_ACCESS',
  'RESET_PASSWORD',
  'REVIEW_PRODUCT_SIGNUP',
  'SHOW_BALANCES',
  'UPLOAD_REPORTS',
  'VIEW_ACCOUNT_BALANCE',
  'VIEW_ATTACHMENT',
  'VIEW_MACRO_EVENT',
  'VIEW_PRODUCT',
  'VIEW_PROFILE',
  'VIEW_PWM_CUSTOMERS',
  'VIEW_PWM_REPORTS',
  'VIEW_USER',
];

export const privileges = [
  'ACTIVATE_USER',
  'ADMIN_OPTIONS',
  'CREATE_CRM_X_USER',
  'CREATE_PRODUCT',
  'CRM_X_VIEW_ONLY',
  'CUSTOMER_OPTIONS',
  'DOWNLOAD_REPORTS',
  'DOWNLOAD_CUSTOMER_LIST',
  'EDIT_PROFILE',
  'LIST_CUSTOMER',
  'MONITOR_PRODUCT_SIGNUPS',
  'PRODUCT_SIGNUP',
  'RESEARCH_PORTAL_FULL_ACCESS',
  'RESEARCH_PORTAL_NO_ACCESS',
  'RESEARCH_PORTAL_PARTIAL_ACCESS',
  'RESET_PASSWORD',
  'REVIEW_PRODUCT_SIGNUP',
  'SHOW_BALANCES',
  'UPLOAD_REPORTS',
  'VIEW_ACCOUNT_BALANCE',
  'VIEW_ATTACHMENT',
  'VIEW_PRODUCT',
  'VIEW_PROFILE',
  'VIEW_USER',
];

export const userRoles = {
  ROLE_RM_CALS: [{ description: 'RM CALS' }],
  // ROLE_RM_CALT: [{ description: 'RM CALT' }],
  ROLE_RM_CALI: [{ description: 'RM CALI' }],
  // ROLE_RM_PWM: [{ description: 'RM PWM' }],
  ROLE_NON_PRODUCT_RM: [{ description: 'Non Product RM' }],
  ROLE_DOCUMENTATION_OFFICER: [{ description: 'Documentation Officer' }],
  ROLE_SENIOR_DOCUMENTATION_OFFICER: [{ description: 'Senior Doc Officer' }],
  ROLE_ADMIN: [{ description: 'Administrator' }],
  // ROLE_CRM_X_USER: [{ description: 'CRM X User' }],
  // ROLE_CRMX_EDITOR: [{ description: 'CRM X Editor' }],
  ROLE_RESEARCH_ADMIN: [{ description: 'Research Administrator' }],
  ROLE_CUSTOMER: [{ description: 'Customer' }],
  ROLE_PWM_USER: [{ description: 'PWM User' }],
  // ROLE_PWM_EDITOR: [{ description: 'PWM Editor' }],
  // ROLE_PWM_REVIEWER: [{ description: 'PWM Reviewer' }],
  // ROLE_RM_CORP_FIN: [{ description: 'RM Corporate Finance' }],
  // ROLE_MACRO_VIEWER: [{ description: 'Macro Event Viewer' }],
  // ROLE_CORPORATE_USER: [{ description: 'Corp User' }],
  ROLE_COMPLIANCE: [{ description: 'Compliance' }],
};
